<template>
    <div>
        <div class="input-group">
            <label for="generic-service-username">Service Username:</label>
            <input id="generic-service-username" type="text" v-model="ServiceUsername"
                placeholder="Servis kullanıcı adını girin" />
        </div>
        <div class="input-group">
            <label for="generic-service-password">Service Password:</label>
            <input id="generic-service-password" type="text" v-model="ServicePassword"
                placeholder="Servis şifresini girin" />
        </div>
        <div class="input-group">
            <label for="generic-service-security-key">Service Security Key:</label>
            <input id="generic-service-security-key" type="text" v-model="ServiceSecurityKey"
                placeholder="Servis güvenlik anahtarını girin" />
        </div>
        <div class="input-group">
            <label for="generic-address">API URL:</label>
            <input id="generic-address" type="text" v-model="Address" placeholder="API URL girin" />
        </div>
        <v-btn color="primary" class="mt-4" @click="saveProviderConfig">
            Kaydet
        </v-btn>
    </div>
</template>

<script>
export default {
    name: "GenericProviderInput",
    props: {
        providerData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            ServiceUsername: "",
            ServicePassword: "",
            ServiceSecurityKey: "",
            Address: "",
        }
    },
    watch: {
        // Üst bileşenden gelen veriyi izler ve formu doldurur/temizler
        providerData: {
            handler(newValue) {
                this.fillForm(newValue);
            },
            deep: true,
            immediate: true // Sayfa ilk açıldığında da çalışmasını sağlar
        }
    },
    methods: {
        fillForm(data) {
            // data doluysa alanları eşitle
            if (data && Object.keys(data).length > 0) {
                this.ServiceUsername = data.ServiceUsername || "";
                this.ServicePassword = data.ServicePassword || "";
                this.ServiceSecurityKey = data.ServiceSecurityKey || "";
                this.Address = data.Address || "";
            } else {
                // data boş veya null ise alanları temizle
                this.ServiceUsername = "";
                this.ServicePassword = "";
                this.ServiceSecurityKey = "";
                this.Address = "";
            }
        },
        saveProviderConfig() {
            if (!this.ServiceUsername || !this.ServicePassword || !this.ServiceSecurityKey || !this.Address)
                return this.$toast.error("Lütfen tüm alanları doldurun.");

            // ID kontrolüne göre add/edit modu belirlenir
            const type = this.providerData && this.providerData.Id ? 'edit' : 'add';

            const config = {
                ServiceUsername: this.ServiceUsername,
                ServicePassword: this.ServicePassword,
                ServiceSecurityKey: this.ServiceSecurityKey,
                Address: this.Address,
            }
            this.$emit("save", config, type);
        }
    }
}
</script>

<style scoped>
div {
    font-family: 'Roboto', sans-serif;
}

.input-group {
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
}

.input-group label {
    margin-bottom: 8px;
    font-weight: 500;
    color: #333;
    font-size: 14px;
}

.input-group input {
    padding: 10px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: all 0.3s ease;
}

.input-group input:focus {
    outline: none;
    border-color: #1976d2;
    box-shadow: 0 0 0 3px rgba(25, 118, 210, 0.1);
}

.input-group input::placeholder {
    color: #999;
}

.mt-4 {
    margin-top: 16px;
    padding: 10px 24px;
    font-size: 14px;
    font-weight: 500;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.2s ease;
}
</style>